import { ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';

export const bootstrap = (app: ReactNode) => {
  const domNode = document.getElementById('root');
  createRoot(domNode).render(app as any);
};

unregisterServiceWorker();
